var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDeepSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.41 41.348c4.83-4.687 10.419-6.578 15.805-6.29 5.32.285 10.248 2.68 13.927 6.216 3.677 3.535 6.24 8.34 6.638 13.601.344 4.526-.933 9.206-4.191 13.472L93.12 87.879a3 3 0 11-4.242 4.242l-19.54-19.539c-9.316 7.03-20.6 4.255-27.46-2.212-3.726-3.514-6.378-8.284-6.799-13.513-.428-5.319 1.483-10.804 6.33-15.51zm15.485-.297c-3.66-.196-7.634 1.039-11.305 4.601-3.653 3.545-4.804 7.31-4.53 10.725.283 3.506 2.1 6.954 4.935 9.628 5.695 5.37 14.572 6.944 21.383.372 3.536-3.66 4.686-7.534 4.42-11.049-.273-3.599-2.055-7.075-4.815-9.727-2.758-2.652-6.362-4.35-10.089-4.55zM31.5 40.5a3 3 0 110 6h-17a3 3 0 110-6h17zm10.5-12a3 3 0 110 6H14.5a3 3 0 110-6H42zM65 30V7a1 1 0 00-1-1H7a1 1 0 00-1 1v69.5a1 1 0 001 1h36.5a3 3 0 110 6H7a7 7 0 01-7-7V7a7 7 0 017-7h57a7 7 0 017 7v23a3 3 0 11-6 0zM54.5 16a3 3 0 110 6h-40a3 3 0 110-6h40z",
    fill: "#CDCDCD"
  })));
}

export default SvgIconDeepSearch;